module.exports = __webpack_public_path__ + "static/media/responsum.bf12f360.png";